;(function () {
  window.initMembersShow = function () {
    if ($(".coetanen-list").length > 0) {
      $(".coetanen-list").animate(
        {
          scrollLeft:
            $(".coetanen-list .active").position().left -
            $(".coetanen-list").width() / 2 +
            $(".coetanen-list .active").width() / 2,
        },
        100
      )
    }
    $("#changelog_btn").click(function () {
      return $("#changelog").modal("show")
    })
    return $("#support_info_btn").click(function () {
      return $("#support_info").modal("show")
    })
  }
}).call(this)
